const Header = () => (
  <div className=''>
    <div className=' text-center  max-md:text-left'>
      <div className='max-w-160 mx-auto mb-4 text-h3 max-lg:max-w-120 max-lg:text-h4'>
        Terms & Conditions
      </div>
      <div className='max-w-142 mx-auto mb-4 text-[1.125rem] font-medium tracking-[-0.01em] text-t-secondary'>
        User Service Terms and Conditions
      </div>
    </div>
  </div>
);

export default Header;
